export default {
  criteria: {
    doc_code: '',
    doc_date: null
  },

  sorts: [],

  reportData: [],

  pagination: {
    current: 1,
    pageSize: 20,
    total: 0
  },

  reportIsLoading: false,
  exportIsLoading: false
};
